import { assertValidVersion } from "@tsparticles/engine";
import { StrokeColorUpdater } from "./StrokeColorUpdater.js";
export async function loadStrokeColorUpdater(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addParticleUpdater("strokeColor", container => {
        return Promise.resolve(new StrokeColorUpdater(container, engine));
    }, refresh);
}
